import React from "react";
import aboutHeroImage from "../assets/Group 1000001705.png";
import aboutCityOverlay from "../assets/real-estate-concept-with-cityscape-mixed-media.png";
import VisionImage from '../assets/vision-svgrepo-com.png'
import MissionImage from '../assets/bionic-contact-lens-svgrepo-com.png'

function AboutPage() {
  return (
    <main>
      <section className="page-hero about-hero bg_image">
        <div className="container">
          <div className="about-hero-inner">
            <div className="about-hero-text">
              <h1 className="section-title">
                DHANVANTI
              </h1>
              <h1 className="section-title-subheading">LUXURY BUILDERS PVT. LTD.</h1>
            </div>
          </div>
          <div className="about-hero-image">
            <img src={aboutHeroImage} alt="About Dhanvanti" />
          </div>
        </div>
      </section>

      <section className="section about-main">
        <div className="container about-main-inner">
          <div className="about-main-text">
            <h2 className="eyebrow">Where values</h2>
            <h2 className="about-heading">build <span>Homes</span></h2>
            <p>
              At Dhanvanti Luxury Builders Pvt. Ltd., real estate is not just about land, concrete, andconstruction — it is about belief, responsibility, and long-term relationships. Rooted indecades of entrepreneurial experience across diverse industries, Dhanvanti LuxuryBuilders was founded with a clear purpose: to create well-planned, thoughtfully located, and responsibly developed spaces that people can truly call their own.
            </p>
            <p>
             Every project we undertake is guided by a simple yet powerful philosophy —trust must be the foundation of everything we build.
            </p>
            <p>
            From transparent dealings and ethical practices to quality construction and customercommitment, our approach is grounded in honesty and long-term value.
            </p>
            <p>
             We believe that a home or investment is one of life’s most important decisions. That is why we design developments that are not only structurally strong, but emotionallyreassuring — places that feel secure, connected, and enduring.
            </p>
          </div>
          <div className="about-main-image">
            <img src={aboutCityOverlay} alt="City and architect" />
          </div>
        </div>
      </section>

      <section className="about-panels">
        <div className="container about-panels-grid">

          {/* VISION TEXT */}
          <div className="panel-text">
            <h2 className="panel-title">
              <span>Our</span> <br></br>Vision
            </h2>
            <p>
              To become a benchmark in luxury and trust-driven real estate development,
              known for creating projects that enhance location quality, sustainability,
              and human well-being.
            </p>
            <p className="panel-highlight">
              We envision communities that grow in value, relevance,
              and pride — today and for generations to come.
            </p>
          </div>

          {/* VISION ICON */}
          <div className="panel-icon large">
              <img src={MissionImage} alt="vision" style={{height: '300px'}}/>
          </div>

          {/* MISSION ICON */}
          <div className="panel-icon">
            <img src={VisionImage} alt="misson" style={{height: '300px'}}/>
          </div>

          {/* MISSION TEXT */}
          <div className="panel-text">
            <h2 className="panel-title">
              <span>Our</span> <br></br>Mission
            </h2>

            <ul className="mission-list">
              <li>Develop strategically located residential and commercial projects</li>
              <li>Deliver transparent, customer-centric experiences</li>
              <li>Maintain uncompromising standards of quality</li>
              <li>Create developments that respect nature and community</li>
              <li>Build long-term trust with stakeholders</li>
            </ul>

            <p className="panel-bottom-line">
              At Dhanvanti, success is not measured only by square feet delivered,
              but by confidence earned.
            </p>
          </div>

        </div>
      </section>

      <section className="section about-contact">
        <div className="container about-contact-inner">
          <div className="about-contact-text">
            <h3 className="eyebrow">Get in</h3>
            <h3 className="about-heading">Touch</h3>
            <p>
              Reach out to us today and let’s start buildingyour dream together. Your satisfaction is our priority.              
            </p>
          </div>
          <div className="about-contact-card">
            <h4>Book a Site Visit Now</h4>
            <p className="contact-subtitle">Fill in the form.</p>
            <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
              <div className="form-row">
                <div className="form-field">
                  <input type="text" placeholder="First name" />
                </div>
                <div className="form-field">
                  <input type="text" placeholder="Last name" />
                </div>
              </div>
              <div className="form-row">
                <div className="form-field">
                  <input type="email" placeholder="Email address" />
                </div>
                <div className="form-field">
                  <input type="tel" placeholder="Phone" />
                </div>
              </div>
              <div className="form-field">
                <textarea
                  rows="3"
                  placeholder="Share any details you would like us to know."
                />
              </div>
              <div className="form-actions">
                <button type="submit" className="btn-primary">
                  Request to call back
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default AboutPage;